import { getArrayTableColumns } from "../../../../../../extensions/json-schema/arrayTableModel";
import {
	JsonSchemaDefinition,
	hasSchemaType,
	isSchemaPropertyVisible
} from "../../../../../../extensions/json-schema/schemaFormModel";

const schemaProperties = (schema: JsonSchemaDefinition) => schema?.properties ?? {};

export function hasEntitySchemaValue(value) {
	if(value === undefined || value === null || value === "") {
		return false;
	}

	if(Array.isArray(value)) {
		return value.some(hasEntitySchemaValue);
	}

	if(typeof value === "object") {
		return Object.values(value).some(hasEntitySchemaValue);
	}

	return true;
}

export function formatEntitySchemaValue(value) {
	if(value === undefined || value === null || value === "") {
		return "--";
	}

	if(typeof value === "boolean") {
		return value ? "Yes" : "No";
	}

	if(Array.isArray(value)) {
		return value.length > 0 ? value.join(", ") : "--";
	}

	if(typeof value === "object") {
		return JSON.stringify(value);
	}

	return value;
}

export function buildEntitySchemaDisplay(
	schema: JsonSchemaDefinition,
	model: Record<string, unknown> = {}
) {
	const display = Object.entries(schemaProperties(schema))
		.filter(([key]) => isSchemaPropertyVisible(schema, key, model))
		.reduce<{
			fields: Array<Record<string, unknown>>;
			objects: Array<Record<string, unknown>>;
			tables: Array<Record<string, unknown>>;
			hasContent: boolean;
		}>((state, [key, propertySchema]) => {
			const entry = {
				key,
				title: propertySchema.title || key,
				description: propertySchema.description,
				schema: propertySchema,
				value: model?.[key]
			};

			if(hasSchemaType(propertySchema, "object")) {
				state.objects.push({
					...entry,
					model: entry.value ?? {},
					isEmpty: !hasEntitySchemaValue(entry.value)
				});
				return state;
			}

			if(hasSchemaType(propertySchema, "array")
				&& hasSchemaType(propertySchema.items, "object")) {
				state.tables.push({
					...entry,
					columns: getArrayTableColumns(propertySchema),
					rows: Array.isArray(entry.value) ? entry.value : []
				});
				return state;
			}

			state.fields.push({
				...entry,
				displayValue: formatEntitySchemaValue(entry.value)
			});
			return state;
		}, {
			fields: [],
			objects: [],
			tables: [],
			hasContent: false
		});

	display.hasContent = display.fields.length > 0
		|| display.objects.length > 0
		|| display.tables.length > 0;

	return display;
}
